import { GuardedComponent } from '../components/guarded-component';
import { GuardedComponentMulti } from '../components/guarded-component-multi';
import { WorkOrderInspectionReportPage } from '../features/work-order-inspection-report/work-order-inspection-report.page';
import { UserPermissionName } from '../models/user-permission-name';

export const WorkorderInspectionReportRoute = {
  path: '/workorder-inspection-report',
  name: 'Work Order Inspection Reports',
  element: (
    <GuardedComponentMulti
      requiredPermissions={[UserPermissionName.VIEW_OWN_INSPECTIONS, UserPermissionName.VIEW_ALL_INSPECTIONS]}
      showPermissionError
    >
      <WorkOrderInspectionReportPage />
    </GuardedComponentMulti>
  ),
};
